<template>
    <div style="min-height:80vh">
        <ol class="breadcrumb pull-right">
			<li class="breadcrumb-item"><a href="javascript:;">Home</a></li>
			<li class="breadcrumb-item active"> Mapping Report</li>
		</ol>

        <h1 class="page-header"> Mapping Report</h1>
        <hr>

        <panel class="border border-secondary" :noExpand="true">
            <template slot="header">
                <h4 class="panel-title">Filter Mapping Report</h4>
            </template>
            <div class="row">
                <div class="form-group col-md-4">
                    <label>Mapping Location</label>
                    <Multiselect 
                        v-model="uFilter.type"
                        :options="['PDC' , 'DEALER']"
                    />
                </div>
                <div class="form-group col-md-4">
                    <label for="staticEmail">Location :</label>
                    <Multiselect 
                        v-if="options.pdc && options.dealer"
                        v-model="uFilter.location"
                        :options="uFilter.type == 'PDC' ? options.pdc : options.dealer"
                        :placeholder="uFilter.type == 'PDC' ? 'All PDC' : 'All Dealers'"
                    />
                </div>
                <div class="form-group col-md-4" style="display: flex; flex-direction: column; justify-content: flex-end;">
                    <button class="btn btn-primary w-100" style="height: 43px;" @click="updateAll">Search</button>
                </div>
            </div>
        </panel>

        <!--Daily Mapping Vehicles Start-->
        <div class="row mb-2 mt-5">
            <div class="col-md-3">
                <h4>Daily Mapping Vehicles</h4>
            </div>
            <div class="col-md-1" style="display: flex; align-items: center">
                <p class="m-0">Date :</p>
            </div>
            <div class="col-md-3 col">
                <date-range-picker id="dateTimeInput" v-model="dateRange" style="width:100%" >
                    <div slot="input" class="text-center" slot-scope="picker" opens="right" >
                        <i class="fa fa-calendar fa-fw text-white-transparent-5 ml-n1"></i> 
                        {{ moment(dateRange.startDate).format("DD MMMM YYYY")}} - {{ moment(dateRange.endDate).format("DD MMMM YYYY")}}
                        <b class="caret"></b>
                    </div>
                </date-range-picker>
            </div>
        </div>
        <scanActivityByDay
            class="mt-3"
            :filter="filter.dailyMapping"
            :update="update.dailyMapping"
        ></scanActivityByDay>
        <!--Daily Mapping Vehicles End-->

        <!-- Monthly Mapping Vehicles Start -->
        <div class="row mb-2 mt-5">
            <div class="col-md-3">
                <h4>Monthly Mapping Vehicles</h4>
            </div>
            <div class="col-md-1" style="display: flex; align-items: center">
                <p class="m-0">Year :</p>
            </div>
            <div class="col-md-3 col">
                <select class="form-control" v-model="filter.monthlyMapping.year">
                    <option v-for="year in options.year">{{year}}</option>
                </select>
            </div>
        </div>

        <!-- Monthly Mapping Chart Start -->
        <scanActivityByMonth
            v-if="monthlyData"
            :data="monthlyData"
        ></scanActivityByMonth>
        <!-- Monthly Mapping Chart End -->

        <!-- Monthly Mapping Table Start -->
        <mappingTableYear
            class="mt-3"
            v-if="monthlyData"
            :data="monthlyData"
            :year="filter.monthlyMapping.year"
        ></mappingTableYear>
        <!-- Monthly Mapping Table End -->
        
        <!-- Summary Mapping Start -->
        <h5 class="mb-2 mt-3">Mapping Summary {{ filter.monthlyMapping.year }}</h5>
        <reportLogTable
            :filter="filter.monthlyMapping"
            :update="update.monthlyMapping"
        ></reportLogTable>
        <!-- Summary Mapping End -->
        <!-- Monthly Mapping Vehicles End -->
        
    </div> 
</template>

<script>
    import qs from 'qs';
    import DateRangePicker from "vue2-daterange-picker";
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
    import moment from 'moment';
    import Multiselect from 'vue-multiselect'

    // import child components
    import scanActivityByDay from './childComponents/charts/scanActivityByDay'
    import scanActivityByMonth from './childComponents/charts/scanActivityByMonth'
    import mappingTableYear from './childComponents/mappingTableYear'
    import reportLogTable from './childComponents/reportLogTable'
    
    export default{
        data(){
            var startDate = moment().startOf('month')._d;

            let yearNow = new Date().getFullYear();
            let yearList = [];
            for(var i = 0 ; i < 15 ; i++){
                yearList.push(yearNow - i);
            }

            return{
                moment : moment,
                dateRange: {
                    startDate : startDate,
                    endDate : new moment()._d
                },
                uFilter : {
                    location : '',
                    type : 'PDC'
                },
                filter : {
                    dailyMapping : {
                        start_date  : moment(startDate).format('YYYY-MM-DD') + " 06:30:00",
                        end_date : moment().add(1 ,'d').format('YYYY-MM-DD') + " 06:29:59",
                    },
                    monthlyMapping : {
                        year : new Date().getFullYear(),
                    }
                },
                update : {
                    dailyMapping:0,
                    monthlyMapping:0,
                    summaryMapping:0
                },
                options : {
                    dealer : this.$store.getters.getDealer.map(x=>x.dealer),
                    pdc : this.$store.getters.getPdc,
                    year : yearList,
                },
                monthlyData : null,
            }
        },
        components : {
            DateRangePicker,
            Multiselect,

            scanActivityByDay,
            scanActivityByMonth,
            mappingTableYear,
            reportLogTable,
        },
        beforeDestroy(){
            am4core.disposeAllCharts();
            this.$store.state.filterUrl = '';
        },
        watch : {
            'dateRange' () {
                this.filter.dailyMapping.start_date = `${moment(this.dateRange.startDate).format('YYYY-MM-DD')} ${this.uFilter.type == 'PDC' ? '06:30:01' : '00:00:00'}`;
                this.filter.dailyMapping.end_date = `${moment(this.dateRange.endDate).add(1 ,'d').format('YYYY-MM-DD')} ${this.uFilter.type == 'PDC' ? '06:30:00' : '23:59:59'}`;
                this.update.dailyMapping++;
            },
            'uFilter' : {
                deep : true,
                immediate : true,
                handler () {
                    for (var i in this.filter) {
                        for (var j in this.uFilter) {
                            this.filter[i][j] = this.uFilter[j];
                        }
                    }
                }
            },
            'uFilter.type' : function() {
                this.uFilter.location = null;
            },
            'update.monthlyMapping' : {
                handler () {
                    this.fetchMonthlyData();
                },
                deep : true,
            },
            'filter.monthlyMapping.year' : {
                handler () {
                    this.update.monthlyMapping++;
                }
            },
        },
        mounted(){
            this.updateAll();
        },
        methods : {
            updateAll(){
                for (var i in this.update) this.update[i]++;
            },
            fetchMonthlyData() {
                this.$http.get(`/api/vehicle/count/map-by-month${qs.stringify(this.filter.monthlyMapping, {skipNulls:true, addQueryPrefix:true})}`)
                .then((resp)=>{
                    this.monthlyData = resp.data.data;
                })
                .catch((err)=>{console.log(err)})
            },
        }
    }
</script>
<style scoped>
    
</style>